import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="0 0 19 17"
  return (
    <>
      <path
        fill={color}
        d="M8.702 3.376c.326 0 .59.267.59.597v4.851a.6.6 0 0 1-.136.382l-2.386 2.92a.592.592 0 0 1-.834.082.605.605 0 0 1-.08-.841l2.25-2.754V3.977c0-.33.263-.597.589-.597l.007-.004ZM14.495 17c-2.485 0-4.505-2.046-4.505-4.562 0-2.517 2.02-4.562 4.505-4.562S19 9.92 19 12.438C19 14.954 16.98 17 14.495 17Zm0-8.013c-1.877 0-3.407 1.55-3.407 3.45 0 1.902 1.53 3.451 3.407 3.451s3.407-1.549 3.407-3.45c0-1.902-1.53-3.45-3.407-3.45Z"
      />
      <path
        fill={color}
        d="M10.506 15.57c-.67.203-1.38.318-2.111.318-4.022 0-7.293-3.313-7.293-7.386s3.267-7.39 7.29-7.39c3.666 0 6.703 2.757 7.212 6.334.406.092.794.237 1.156.422C16.438 3.476 12.808 0 8.391 0S0 3.814 0 8.498c0 4.685 3.766 8.498 8.391 8.498a8.257 8.257 0 0 0 2.972-.552 5.083 5.083 0 0 1-.857-.878v.003Z"
      />
      <path
        fill={color}
        d="M14.495 13.82c-.358 0-.647-.256-.647-.574a.329.329 0 0 0-.326-.33.329.329 0 0 0-.326.33c0 .57.414 1.052.973 1.19v.222c0 .181.147.33.326.33.18 0 .326-.149.326-.33v-.223c.556-.137.973-.619.973-1.19 0-.677-.582-1.23-1.295-1.23-.359 0-.648-.256-.648-.574 0-.319.29-.575.648-.575.358 0 .648.256.648.575 0 .181.146.33.325.33.18 0 .326-.149.326-.33 0-.57-.414-1.053-.973-1.19v-.222a.328.328 0 0 0-.326-.33.328.328 0 0 0-.326.33v.222c-.556.137-.973.62-.973 1.19 0 .678.582 1.23 1.295 1.23.359 0 .648.256.648.575 0 .318-.29.574-.648.574Z"
      />
    </>
  );
}
